import { PageError404 } from '@flecto/modules-store'

export default function Page() {
  return <PageError404 />
}
